import Request from './request';
import { FAQResult, PrivacyPolicyResult } from '@/types/RequestTypes';
import { Language } from '@/enums/language';
import LiveConfig from '@/types/LiveConfig';

export default class Tg4 {
  private noAuthRequest = new Request()


  async getFAQ(language: Language): Promise<FAQResult> {
    return await this.noAuthRequest.get<FAQResult>(`https://tg4-platforms.s3-eu-west-1.amazonaws.com/mobileapps/FAQ${language}.json`);
  }

  async getPrivacyPolicy(language: Language): Promise<PrivacyPolicyResult> {
    let apiEndpoint: string

    switch (language) {
      case Language.Irish: {
        apiEndpoint = "https://tg4-platforms.s3-eu-west-1.amazonaws.com/mobileapps/irish_privacy.json";
        break;
      }
      case Language.English: {
        apiEndpoint = "https://tg4-platforms.s3-eu-west-1.amazonaws.com/mobileapps/english_privacy.json";
        break; 
      }
    }
    return await this.noAuthRequest.get<PrivacyPolicyResult>(apiEndpoint);
  }

  async getLiveConfig(): Promise<LiveConfig> {
    return await this.noAuthRequest.get<LiveConfig>(`https://tg4-platforms.s3-eu-west-1.amazonaws.com/smartTV/playback_config.json`, { cache: 'no-store' });
  }


}